import React from 'react';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import type EntityContentType from '@/constants/EntityContentType';
import translate from '@/lib/intl/translate';
import EntitySummaries from '../constants/EntitySummaries';

type EntityDetailsSummaryProps = {
  children: React.ReactNode;
  created?: string;
  entityId: string;
  entityType: EntityContentType;
  pinned?: boolean;
};

export default function EntityDetailsSummary({
  children,
  created,
  entityId,
  entityType,
  pinned = false,
}: EntityDetailsSummaryProps) {
  const summary = EntitySummaries[entityType];

  return (
    <div data-testid={`entity-details-summary-${entityId}`}>
      <div className="mb-2 flex items-center type-caption1">
        <img className="mr-2 h-4" src={summary.icon} alt="" />
        <span className="mr-2 font-semibold" style={{ color: summary.color }}>
          {summary.label}
        </span>
        {created && isValid(created) && (
          <span className="mr-2">{format(new Date(created), 'PP')}</span>
        )}
        {pinned && (
          <span className="text-lightBlue">{translate('PINNED')}</span>
        )}
      </div>

      {children}
    </div>
  );
}
